import React, { useEffect, useState } from "react";
import { tranding_category_filter } from "../../data/categories_data";
import CategoryItem from "./categoryItem";
import { trendingCategoryData } from "../../data/categories_data";
import Tippy from "@tippyjs/react";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import { useSelector, useDispatch } from "react-redux";
import { updateTrendingCategoryItemData } from "../../redux/marketplaceSlice";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet,
  WalletConnectButton,
} from "@sei-js/react";
import { COLLECTIONS } from "../../config";
import LoadingComp from "../loading/loading";
import { getUserNfts, getOwnedNfts, getAllCollection } from "../../utils/api";

const Trending_categories_items = () => {
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const [itemdata, setItemdata] = useState();
  const dispatch = useDispatch();
  const { seiWallet } = useSelector((state) => state.marketplace);
  const [filterVal, setFilterVal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState([]);

  const getAllNfts = async () => {
    const collectionRes = await getAllCollection(0)
    let collectionData = []
    if (collectionRes.length > 0) {
      collectionData = collectionRes.map(e => e.contract)
      setCollections(collectionData)
    }

    const nfts = await getUserNfts(collectionData, seiWallet)
    setItemdata(nfts)
    dispatch(updateTrendingCategoryItemData(nfts));
    setLoading(false)
  }

  // const getNfts = async () => {
  //   setLoading(true);
  //   const collectionRes = await getAllCollection(0)
  //   const colelctions = collectionRes.map(e => e.contract) 
  //   let nfts = []

  //   const data = await getOwnedNfts(colelctions, seiWallet)
  //   for (let i = 0; i < data.length; i++) {
  //     const item = data[i]
  //     nfts.push({
  //       attributes: item.traits,
  //       image: item.image,
  //       contract: item.contract,
  //       address: seiWallet,
  //       token_id: item.tokenid,
  //       category: "art",
  //       title: item.name,
  //       name: item.name,
  //       symbol: item.symbol,
  //       description: item?.description || "description",
  //       list: false,
  //       likes: 1,
  //       nfsw: true,
  //     });
  //   }
  //   console.log('nfts = ', nfts)
  //   setItemdata(nfts);
  //   console.log("nfts: ", nfts);
  //   dispatch(updateTrendingCategoryItemData(nfts));
  //   setLoading(false)
  // }

  useEffect(() => {
    seiWallet && getAllNfts()
  }, [seiWallet]);

  const handleFilter = (category) => {
    if (category !== "all") {
      setItemdata(itemdata.filter((item) => item.category === category));
    } else {
      setItemdata(trendingCategoryData);
    }
  };

  const sortText = [
    {
      id: 1,
      text: "All",
    },
    {
      id: 2,
      text: "Price: Low to High",
    },
    {
      id: 3,
      text: "Price: high to low",
    },
  ];

  return (
    <>
      {/* <!-- Filter --> */}
      <div className="mb-8 flex flex-wrap items-center justify-between">
        <div className=" flex">
          <ul className="flex flex-wrap items-center">
            {tranding_category_filter.map(({ id, svg, text }) => {
              if (text === "all") {
                return (
                  <li className="my-1 mr-2.5" key={id}>
                    <button
                      className={
                        filterVal === id
                          ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize"
                          : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize"
                      }
                      onClick={() => {
                        handleFilter(text);
                        setFilterVal(id);
                      }}
                    >
                      {text}
                    </button>
                  </li>
                );
              } else {
                return (
                  <li className="my-1 mr-2.5" key={id}>
                    <button
                      onClick={() => {
                        handleFilter(text);
                        setFilterVal(id);
                      }}
                    >
                      <div
                        className={
                          filterVal === id
                            ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize"
                            : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize"
                        }
                      >
                        <svg
                          className={
                            filterVal === id
                              ? "icon mr-1 h-4 w-4 transition-colors fill-white"
                              : "icon fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white"
                          }
                        >
                          <use xlinkHref={`/icons.svg#icon-${svg}`}></use>
                        </svg>
                        <span>{text}</span>
                      </div>
                    </button>
                  </li>
                );
              }
            })}
          </ul>
          {/* Search */}
          <input
            type="search"
            className=" text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full md:w-72 rounded-2xl border py-[0.2575rem] px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
            placeholder="Search by NFT"
            onChange={(e) => singleNFTSearchInput(e.target.value)}
          />
        </div>
        {/* dropdown */}
        <Recently_added_dropdown data={sortText} dropdownFor="recently_added" />
      </div>

      {/* <!-- Grid --> */}

      {loading ? (
        <div className="loading_box">
          <LoadingComp />
        </div>
      ) : (
        <CategoryItem 
          signingClient={signingClient} 
          allNfts={itemdata} 
          collections={collections}/>
      )}
    </>
  );
};

export default Trending_categories_items;
